import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
/**
 * Loaders dos chunks lazy. Cada `import()` fica sozinho numa linha curta: o
 * autoChunkNameLoader só nomeia e registra imports de uma linha, e um import
 * quebrado pelo formatter vira chunk anônimo que o Flarum não serve.
 */

const importChatUi = () => import(/* webpackChunkName: 'forum/chatUi', webpackMode: 'lazy-once' */ '../chatUi');
let chatUi = null;

/** Pede o chunk da interface uma vez só; se falhar, a próxima chamada tenta de novo. */
export function loadChatUi() {
  chatUi != null ? chatUi : chatUi = importChatUi().catch(error => {
    chatUi = null;
    throw error;
  });
  return chatUi;
}
export const loadChannelFormModal = () => import(/* webpackChunkName: 'forum/components/ChannelFormModal', webpackMode: 'lazy-once' */ '../components/ChannelFormModal');
export const loadChannelInfoModal = () => import(/* webpackChunkName: 'forum/components/ChannelInfoModal', webpackMode: 'lazy-once' */ '../components/ChannelInfoModal');
export const loadAddMembersModal = () => import(/* webpackChunkName: 'forum/components/AddMembersModal', webpackMode: 'lazy-once' */ '../components/AddMembersModal');
export const loadNewDirectModal = () => import(/* webpackChunkName: 'forum/components/NewDirectModal', webpackMode: 'lazy-once' */ '../components/NewDirectModal');
const importChatFlagModal = () => import(/* webpackChunkName: 'forum/components/FlagMessageModal', webpackMode: 'lazy-once' */ '../components/FlagMessageModal');
const importFlagPostModal = () => flarum.reg.asyncModuleImport('ext:flarum/flags/forum/components/FlagPostModal');
const importChatFlagPostModal = () => import(/* webpackChunkName: 'forum/components/ChatFlagPostModal', webpackMode: 'lazy-once' */ '../components/ChatFlagPostModal');

/**
 * Modal de denúncia: o do flarum/flags quando ativo, para a mensagem ser
 * denunciada como um post; senão o do chat.
 */
export async function loadFlagMessageModal() {
  var _flarum$extensions;
  if (!('flarum-flags' in ((_flarum$extensions = flarum.extensions) != null ? _flarum$extensions : {}))) {
    return importChatFlagModal();
  }
  const _await$Promise$all = await Promise.all([importFlagPostModal(), importChatFlagPostModal()]),
    _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
    flags = _await$Promise$all2[0],
    chat = _await$Promise$all2[1];
  return {
    default: chat.default(flags.default)
  };
}
export const loadMessageTooLongModal = () => import(/* webpackChunkName: 'forum/components/MessageTooLongModal', webpackMode: 'lazy-once' */ '../components/MessageTooLongModal');
export const loadImageLightbox = () => import(/* webpackChunkName: 'forum/components/ImageLightbox', webpackMode: 'lazy-once' */ '../components/ImageLightbox');
export const loadStickerPicker = () => import(/* webpackChunkName: 'forum/components/StickerPicker', webpackMode: 'lazy-once' */ '../components/StickerPicker');
flarum.reg.add('ramon-chat', 'forum/utils/lazy', { loadChatUi: loadChatUi,loadChannelFormModal: loadChannelFormModal,loadChannelInfoModal: loadChannelInfoModal,loadAddMembersModal: loadAddMembersModal,loadNewDirectModal: loadNewDirectModal,loadMessageTooLongModal: loadMessageTooLongModal,loadImageLightbox: loadImageLightbox,loadStickerPicker: loadStickerPicker, });flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/chatUi');
flarum.reg.addChunkModule('830', '8822', 'ramon-chat', 'forum/components/ChannelFormModal');
flarum.reg.addChunkModule('768', '3075', 'ramon-chat', 'forum/components/ChannelInfoModal');
flarum.reg.addChunkModule('533', '1501', 'ramon-chat', 'forum/components/AddMembersModal');
flarum.reg.addChunkModule('792', '7714', 'ramon-chat', 'forum/components/NewDirectModal');
flarum.reg.addChunkModule('198', '288', 'ramon-chat', 'forum/components/FlagMessageModal');
flarum.reg.addChunkModule('705', '1503', 'ramon-chat', 'forum/components/ChatFlagPostModal');
flarum.reg.addChunkModule('846', '4702', 'ramon-chat', 'forum/components/MessageTooLongModal');
flarum.reg.addChunkModule('960', '1344', 'ramon-chat', 'forum/components/ImageLightbox');
flarum.reg.addChunkModule('855', '6027', 'ramon-chat', 'forum/components/StickerPicker');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/Skeletons');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/utils/channelIcon');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/utils/duration');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/utils/emoji');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/utils/flamoji');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/utils/iconLabel');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/utils/messageLimit');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/utils/presence');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/utils/ranks');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/utils/stickers');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/ChatPage');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/ChatDrawerPanel');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/BrowseChannelsPage');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/ChatSidebar');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/ChannelView');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/ThreadPanel');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/PinnedPanel');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/ThreadsList');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/ChatSearch');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/ChatMessage');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/ChatComposer');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/ChatSelectionBar');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/ChatAutocomplete');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/FlaggedMessagesList');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/ErrorBoundary');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/components/BookmarksList');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/utils/toolbar');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/utils/channelActions');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/utils/jumpToMessage');
flarum.reg.addChunkModule('345', '6523', 'ramon-chat', 'forum/utils/integrations');
flarum.reg.addChunkModule('830', '8822', 'ramon-chat', 'forum/utils/afterModalClosed');
flarum.reg.addChunkModule('830', '8822', 'ramon-chat', 'forum/components/EmojiPicker');
flarum.reg.addChunkModule('768', '3075', 'ramon-chat', 'forum/components/TransferCodeModal');
flarum.reg.addChunkModule('768', '3075', 'ramon-chat', 'forum/components/ChannelRanksTab');
flarum.reg.addChunkModule('768', '3075', 'ramon-chat', 'forum/utils/rankPalette');